import type React from 'react';
import { useMemo } from 'react';

import { useEventListFilters } from '@vlabs/monokit/entities/events/filters/useEventListFilters';
import { FilterMenuButton } from '@vlabs/monokit/shared/ui/filter-menu';

import st from './EventListFilterButton.module.sass';

function EventListFilterMenuButton(): React.JSX.Element {
  const { filters } = useEventListFilters();

  const filtersCount = useMemo(() => {
    const appliedGroups = [
      !!(filters.create_time__lt ?? filters.create_time__gte),
      !!filters.sources,
      !!filters.handler_ids,
      !!filters.top_matching_candidates_label,
      !!filters.tags?.length,
      !!(filters.event_ids?.length ?? filters.external_ids?.length ?? filters.card_ids?.length),
      !!(filters.top_similar_object_similarity__gte ?? filters.top_similar_object_similarity__lt),
      !!(filters.top_similar_object_ids?.length ?? filters.top_similar_card_ids?.length),
      filters.gender !== undefined,
      filters.age__gte !== undefined || filters.age__lt !== undefined,
      !!filters.emotions?.length,
      !!filters.masks?.length,
      !!filters.liveness?.length,
      !!filters.deepfake?.length,
      !!filters.face_ids?.length,
      !!filters.apparent_gender?.length,
      filters.apparent_age__gte !== undefined || filters.apparent_age__lt !== undefined,
      !!(filters.upper_clothing_colors?.length ?? filters.sleeve_lengths?.length),
      !!(filters.lower_garment_colors?.length ?? filters.lower_garment_types?.length),
      !!filters.shoes_apparent_colors?.length,
      !!(filters.headwear_apparent_colors?.length ?? filters.headwear_states?.length),
      !!filters.backpack_states?.length,
      filters.cities !== undefined
      || filters.areas !== undefined
      || filters.districts !== undefined
      || filters.streets !== undefined
      || filters.house_numbers !== undefined
      || filters.origin_longitude !== undefined
      || filters.origin_latitude !== undefined,
      !!filters.track_ids?.length,
      Object.keys(filters).some((key) => key.startsWith('meta.')),
    ];

    return appliedGroups.reduce((count, isApplied) => (isApplied ? count + 1 : count), 0);
  }, [filters]);

  return (
    <FilterMenuButton
      className={st.FilterMenuButton}
      filtersCount={filtersCount}
    />
  );
}

export { EventListFilterMenuButton };
